import request from '@/utils/requestnew'
import baseUrl from './baseUrl'
import commonJs from '@/utils/common'

const BASE_URL = baseUrl + '/MallApi/promotion'

export default {
    //分页
    list(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/list',
            method: 'get',
            params,
        })
    },
    listpros(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/listpros',
            method: 'get',
            params,
        })
    },
    //保存
    save(data) {
        return request({
            url: BASE_URL + '/save',
            method: 'post',
            data
        })
    },
    //商品关联保存
    savegoods(data) {
        return request({
            url: BASE_URL + '/savegoods',
            method: 'post',
            data
        })
    },
    //删除
    delete(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/delete',
            method: 'get',
            params
        })
    },
    listpage(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/listpage',
            method: 'get',
            params,
        })
    },
    //删除
    deletegoods(params) {
        params = params && commonJs.obj.removeNullKey(params)
        return request({
            url: BASE_URL + '/deletegoods',
            method: 'get',
            params
        })
    },

}